// extracted by mini-css-extract-plugin
module.exports = {"history":"History_history__32ge_","table":"History_table__3HrSa","buttons":"History_buttons__99wmX"};